module.exports = __webpack_public_path__ + "img/ad1c091ffad427d7.png";